const scale = {
  data() {
    return {
      scale: 1
    }
  },
  mounted() {
    if (document.documentElement.style.zoom) {
      this.scale = document.documentElement.style.zoom
    }
  }
}

export default scale
